
class LocationFix {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.latitude = jsonData.latitude;
		this.longitude = jsonData.longitude;
		this.speed = jsonData.speed;
		this.heading = jsonData.heading;
		this.satellites = jsonData.satellites;
		this.hdop = jsonData.hdop;
		this.pdop = jsonData.pdop;
		this.vdop = jsonData.vdop;
	}

} 

class GnssStatus {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.id = jsonData.id;
		this.eboardId = jsonData.eboardId;
		this.time = jsonData.time;
		this.elapsedTime = jsonData.elapsedTime;
		this.state = jsonData.state;
		this.satellites = jsonData.satellites;
		this.gnssTime = jsonData.gnssTime;
		this.fixMode = jsonData.fixMode;

		if (jsonData.fix) {
			this.fix = new LocationFix(jsonData.fix);
		}

	}

} 

class ControllerStatus {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.id = jsonData.id;
		this.eboardId = jsonData.eboardId;
		this.time = jsonData.time;
		this.elapsedTime = jsonData.elapsedTime;
		this.state = jsonData.state;
	}

} 

class GsmStatus {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.id = jsonData.id;
		this.eboardId = jsonData.eboardId;
		this.time = jsonData.time;
		this.elapsedTime = jsonData.elapsedTime;
		this.networkTime = jsonData.networkTime;
		this.state = jsonData.state;
		this.signalStrength = jsonData.signalStrength;
		this.networkStatus = jsonData.networkStatus;
		this.gprs = jsonData.gprs;
	}

} 

class AccelerometerStatus {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.id = jsonData.id;
		this.eboardId = jsonData.eboardId;
		this.time = jsonData.time;
		this.elapsedTime = jsonData.elapsedTime;
		this.state = jsonData.state;
		this.moving = jsonData.moving;
		this.temperature = jsonData.temperature;
	}

} 

class StorageStatus {

	constructor(jsonData) {
		if (!jsonData) {
			jsonData = {}
		}

		this.id = jsonData.id;
		this.eboardId = jsonData.eboardId;
		this.time = jsonData.time;
		this.elapsedTime = jsonData.elapsedTime;
		this.state = jsonData.state;
		this.free = jsonData.free;
		this.used = jsonData.used;
	}

}

export { LocationFix, GnssStatus, ControllerStatus, GsmStatus, AccelerometerStatus, StorageStatus };